import { render, staticRenderFns } from "./ReturnInvice.vue?vue&type=template&id=b84a1640&scoped=true"
import script from "./ReturnInvice.vue?vue&type=script&lang=js"
export * from "./ReturnInvice.vue?vue&type=script&lang=js"
import style0 from "./ReturnInvice.vue?vue&type=style&index=0&id=b84a1640&prod&scoped=true&lang=css"
import style1 from "./ReturnInvice.vue?vue&type=style&index=1&id=b84a1640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84a1640",
  null
  
)

export default component.exports